import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "16ea0c96-8440-4d57-9ade-e29fda3cd91c",
  publicId: "26",
  name: "Materials in practice (Types of materials and common misunderstandings)",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
